import { PayloadEmitter } from "../../core/emitters/payload_emitter.js";
import { Vector3 } from "../../core/types/math_types.js";
import { CatmulromPrecomputed } from "../../utils/catmulrom_precomputed.js";
import { ImgID } from "../../../image_loader/img_id.js";

export enum FireworksColor
{
  Orange,
  Red,
  Green,
  Blue,
  Purple,
}

export interface IFireworksParticleConfig
{
  particle_life_span: number;
  start_size: number;
  end_size: number;
  start_alpha: number;
  end_alpha: number;
  breakpoint: number;
  img_id: ImgID;
  circle_radius?: number;
}

export interface FireworksPayload
{
  color: Vector3;
  precomputed: CatmulromPrecomputed;
  config: IFireworksParticleConfig;
  ease?: ( t: number ) => number;
}

export type FireworksEmitter = PayloadEmitter<FireworksPayload>;